import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { deleteLocalSaveFile } from "../../save/localSave";
import { getUid } from "../../auth/user";
import { deleteGameInCloud, saveGameInCloud } from "../../save/database";

export function DeleteDialog(props: {
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
}) {
  const uid = getUid();
  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <DialogTitle style={{}}>Completly restart the game?</DialogTitle>
      <DialogContent>
        <Typography style={{ opacity: 0.8 }}>
          This will delete all your progress
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setOpen(false)}>Cancel</Button>
        <Button
          onClick={async () => {
            deleteLocalSaveFile();
            if (uid) {
              console.log("called");
              await deleteGameInCloud(uid);
            }
            window.location.reload();
          }}
        >
          Restart
        </Button>
      </DialogActions>
    </Dialog>
  );
}
